import React, { useState, useEffect } from 'react';
import API from '../../services/api';

const AddCustomerModal = ({ onClose, onRefresh }) => {
    const [step, setStep] = useState(1);
    const [cities, setCities] = useState([]);
    const [refs, setRefs] = useState([]);
    
    const [formData, setFormData] = useState({
        full_name: '', father_name: '', cnic: '', phone: '', address: '', city_id: '',
        monthly_income: '', occupation: '', ref_id: '', ref_no: '',
        g1_name: '', g1_father: '', g1_cnic: '', g1_phone: '', g1_address: '', g1_occupation: '',
        g2_name: '', g2_father: '', g2_cnic: '', g2_phone: '', g2_address: '', g2_occupation: ''
    });

    const [images, setImages] = useState({ cnic_front: null, cnic_back: null });

    useEffect(() => {
        const loadInitialData = async () => {
            try {
                const [cRes, rRes] = await Promise.all([API.get('/v1/cities'), API.get('/v1/references')]);
                setCities(cRes.data.data);
                setRefs(rRes.data.data);
            } catch (err) { console.error("Error loading dropdowns", err); }
        };
        loadInitialData();
    }, []);

    const handleNumberInput = (e) => {
        const { name, value } = e.target;
        const onlyNums = value.replace(/[^0-9]/g, ''); 
        setFormData(prev => ({ ...prev, [name]: onlyNums }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFile = (e) => {
        setImages(prev => ({ ...prev, [e.target.name]: e.target.files[0] }));
    };

    // --- MAIN API CALL FUNCTION ---
    const saveCustomerData = async () => {
        // Strict Validations before API call
        if (formData.cnic.length !== 13) return alert("Error: CNIC must be exactly 13 digits!");
        if (formData.phone.length !== 11) return alert("Error: Phone number must be exactly 11 digits!");

        const data = new FormData();
        Object.keys(formData).forEach(key => data.append(key, formData[key]));
        if (images.cnic_front) data.append('cnic_front', images.cnic_front);
        if (images.cnic_back) data.append('cnic_back', images.cnic_back);

        try {
            const res = await API.post('/v1/customers', data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            if (res.data.success) {
                alert("Success: Customer and both Guarantors saved successfully.");
                onRefresh();
                onClose();
            }
        } catch (err) {
            alert(err.response?.data?.error || "Error: Folder not found or Server error.");
        }
    };

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                {/* Steps Header */}
                <div style={styles.stepper}>
                    <div style={step === 1 ? styles.activeStep : styles.step}>1. Personal Info</div>
                    <div style={step === 2 ? styles.activeStep : styles.step}>2. Guarantor 1</div>
                    <div style={step === 3 ? styles.activeStep : styles.step}>3. Guarantor 2</div>
                </div>

                {/* --- FORM SECTION (No onSubmit here to prevent auto-save) --- */}
                <div>
                    {/* STEP 1: CUSTOMER */}
                    {step === 1 && (
                        <div style={styles.grid}>
                            <h4 style={{gridColumn: 'span 2'}}>Customer Details</h4>
                            <input name="full_name" placeholder="Full Name" value={formData.full_name} onChange={handleChange} style={styles.input} />
                            <input name="father_name" placeholder="Father Name" value={formData.father_name} onChange={handleChange} style={styles.input} />
                            <input name="cnic" placeholder="CNIC (13 Digits)" value={formData.cnic} onChange={handleNumberInput} maxLength="13" style={styles.input} />
                            <input name="phone" placeholder="Phone (11 Digits)" value={formData.phone} onChange={handleNumberInput} maxLength="11" style={styles.input} />
                            <input name="occupation" placeholder="Occupation" value={formData.occupation} onChange={handleChange} style={styles.input} />
                            <input name="monthly_income" placeholder="Monthly Income" value={formData.monthly_income} type="number" onChange={handleChange} style={styles.input} />
                            <select name="city_id" value={formData.city_id} onChange={handleChange} style={styles.input}>
                                <option value="">Select City</option>
                                {cities.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                            </select>
                            <input name="ref_no" placeholder="Reference File No" value={formData.ref_no} onChange={handleChange} style={styles.input} />
                            <select name="ref_id" value={formData.ref_id} onChange={handleChange} style={{...styles.input, gridColumn: 'span 2'}}>
                                <option value="">Select Reference</option>
                                {refs.map(r => <option key={r.id} value={r.id}>{r.ref_name}</option>)}
                            </select>
                            <textarea name="address" placeholder="Full Address" value={formData.address} onChange={handleChange} style={{...styles.input, gridColumn: 'span 2'}} />
                            <div style={{gridColumn: 'span 2', background: '#f8fafc', padding: '10px', borderRadius: '8px', border: '1px solid #ddd'}}>
                                <label style={styles.label}>CNIC Front</label>
                                <input type="file" name="cnic_front" onChange={handleFile} />
                                <label style={{...styles.label, marginTop: '10px'}}>CNIC Back</label>
                                <input type="file" name="cnic_back" onChange={handleFile} />
                            </div>
                        </div>
                    )}

                    {/* STEP 2: G1 */}
                    {step === 2 && (
                        <div style={styles.grid}>
                            <h4 style={{gridColumn: 'span 2', color: '#059669'}}>Guarantor 1 Information</h4>
                            <input name="g1_name" placeholder="Name" value={formData.g1_name} onChange={handleChange} style={styles.input} />
                            <input name="g1_father" placeholder="Father Name" value={formData.g1_father} onChange={handleChange} style={styles.input} />
                            <input name="g1_cnic" placeholder="CNIC" value={formData.g1_cnic} onChange={handleNumberInput} maxLength="13" style={styles.input} />
                            <input name="g1_phone" placeholder="Phone" value={formData.g1_phone} onChange={handleNumberInput} maxLength="11" style={styles.input} />
                            <textarea name="g1_address" placeholder="Address" value={formData.g1_address} onChange={handleChange} style={{...styles.input, gridColumn: 'span 2'}} />
                        </div>
                    )}

                    {/* STEP 3: G2 */}
                    {step === 3 && (
                        <div style={styles.grid}>
                            <h4 style={{gridColumn: 'span 2', color: '#059669'}}>Guarantor 2 Information</h4>
                            <input name="g2_name" placeholder="Name" value={formData.g2_name} onChange={handleChange} style={styles.input} />
                            <input name="g2_father" placeholder="Father Name" value={formData.g2_father} onChange={handleChange} style={styles.input} />
                            <input name="g2_cnic" placeholder="CNIC" value={formData.g2_cnic} onChange={handleNumberInput} maxLength="13" style={styles.input} />
                            <input name="g2_phone" placeholder="Phone" value={formData.g2_phone} onChange={handleNumberInput} maxLength="11" style={styles.input} />
                            <textarea name="g2_address" placeholder="Address" value={formData.g2_address} onChange={handleChange} style={{...styles.input, gridColumn: 'span 2'}} />
                        </div>
                    )}

                    {/* --- FOOTER BUTTONS --- */}
                    <div style={styles.footer}>
                        <button type="button" onClick={onClose} style={styles.cancelBtn}>Cancel</button>
                        <div>
                            {step > 1 && (
                                <button type="button" onClick={() => setStep(step - 1)} style={styles.prevBtn}>Back</button>
                            )}
                            
                            {step < 3 ? (
                                <button type="button" onClick={() => setStep(step + 1)} style={styles.nextBtn}>
                                    Next Step
                                </button>
                            ) : (
                                <button 
                                    type="button" 
                                    onClick={saveCustomerData} 
                                    style={styles.submitBtn}
                                >
                                    Save & Finish
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const styles = {
    overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
    modal: { background: '#fff', padding: '30px', borderRadius: '15px', width: '700px', maxHeight: '90vh', overflowY: 'auto' },
    stepper: { display: 'flex', justifyContent: 'space-between', marginBottom: '30px', borderBottom: '1px solid #eee', paddingBottom: '15px' },
    step: { color: '#94a3b8', fontWeight: '500', padding: '10px' },
    activeStep: { color: '#2563eb', fontWeight: 'bold', borderBottom: '3px solid #2563eb', padding: '10px' },
    grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' },
    input: { padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px', outline: 'none' },
    label: { fontSize: '12px', display: 'block', color: '#64748b', marginBottom: '5px', fontWeight: 'bold' },
    footer: { marginTop: '30px', display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #eee', paddingTop: '20px' },
    cancelBtn: { padding: '10px 20px', background: '#f1f5f9', border: 'none', borderRadius: '8px', cursor: 'pointer' },
    nextBtn: { padding: '10px 25px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', marginLeft: '10px' },
    prevBtn: { padding: '10px 25px', background: '#fff', border: '1px solid #cbd5e1', borderRadius: '8px', cursor: 'pointer' },
    submitBtn: { padding: '10px 25px', background: '#10b981', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', marginLeft: '10px', fontWeight: 'bold' }
};

export default AddCustomerModal;